export default {"src":"/accounts/_next/static/media/Users.21972fa3.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};